export default "__VITE_ASSET__BvPMOBkZ__"